<template>
    <v-layout align-center justify-start row mt-4>
      <div class="mb-3">
        <span class="page-side text-uppercase">
          <slot></slot>
        </span>
      </div>
    </v-layout>
</template>

<script>

export default {
  name: 'UIListTitle',
}
</script>

<style scoped lang="stylus">

.page-side
  width 107px
  opacity 0.54
  color #252A30
  font-family Roboto
  font-size 12px
  font-weight 500
  letter-spacing 0.3px
  line-height 14px

</style>